<template>
  <div class="main-content core-agent">
    <p class="title">2026年效果广告核心代理商</p>
    
    <div class="con-list-box">
      <div 
        class="con-item" 
        v-for="agent in agentList"
        :key="agent.companyName"
      >
        <p class="item-name">{{ agent.type }}</p>
        
        <div class="item-content">
          <img 
            class="item-logo" 
            :src="agent.logo"
          >
          
          <ul class="agent-info">
            <li class="agent-info-title">{{ agent.companyName }}</li>
            <li>{{ agent.contactName }} : {{ agent.contactMobile }}</li>
            <li>邮箱 : <br>{{ agent.contactEmail }}</li>
            <li>公司地址 : {{ agent.companyAddress }}</li>
            <li>
              公司官网 :
              <a 
                v-if="agent.companyNetwork" 
                :href="agent.companyNetwork" 
                target="_blank"
              >{{ agent.companyNetwork }}</a>
              <span v-else>无</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    
    <p class="desc">此排序不分先后</p>
  </div>
</template>
<script>
  export default {
    name: 'core-agent',
    data() {
      return {
        agentList: [
          {
            type: '社交汽车',
            logo: '//assets.cnbj1.mi-fds.com/assets/emi/index/agent/weichuang.jpg',
            companyName: '北京微创时代广告有限公司',
            contactName: '宁海莹',
            contactMobile: '13810725446',
            contactEmail: 'ninghaiying@miage.com.cn',
            companyAddress: '北京市朝阳区安家楼路50号院A7-2',
            companyNetwork: 'http://www.leo.cn/'
          }, {
            type: '视频招聘',
            logo: '//assets.cnbj1.mi-fds.com/assets/emi/index/agent/yyhl.jpg',
            companyName: '深圳优普联网络科技有限公司',
            contactName: '王薇薇',
            contactMobile: '13570564310',
            contactEmail: 'wangxiaowei@yoyohulian.com',
            companyAddress: '北京市朝阳区望京北路9号叶青大厦D916',
            companyNetwork: 'http://www.yoyoad.cn'
          }, {
            type: '生活服务',
            logo: '//assets.cnbj1.mi-fds.com/assets/emi/index/agent/adks.jpg',
            companyName: '淮安爱德康赛广告有限公司',
            contactName: '李其童',
            contactMobile: '15611702048',
            contactEmail: 'liqitong@adks.cn',
            companyAddress: '北京朝阳区酒仙桥路10号恒通商务园(UB-P)B10座东区203室',
            companyNetwork: 'http://www.adks.cn/'
          }, {
            type: 'KA电商',
            logo: '//assets.cnbj1.mi-fds.com/assets/emi/index/agent/wabang.jpg',
            companyName: '哇棒移动传媒股份有限公司',
            contactName: '刘琼阳',
            contactMobile: '15510649791',
            contactEmail: 'liuqiongyang@wooboo.com.cn',
            companyAddress: '北京市东城区东四十条甲22号南新仓商务大厦B座11层1123',
            companyNetwork: 'http://www.wooboo.com.cn'
          },{
            type: '金融服务',
            logo: '//assets.cnbj1.mi-fds.com/assets/emi/index/agent/qiyiguo.jpg',
            companyName: '广州奇异果互动科技股份有限公司',
            contactName: '何影利',
            contactMobile: '15112087573',
            contactEmail: 'yingli.he@mokiwi.com',
            companyAddress: '北京市朝阳区光华路5号院世纪财富中心1号楼1001B',
            companyNetwork: 'http://www.mokiwi.com'
          },{
            type: '工具信息',
            logo: '//assets.cnbj1.mi-fds.com/assets/emi/index/agent/tianlong.jpg',
            companyName: '广东天龙科技集团股份有限公司',
            contactName: '王璟',
            contactMobile: '18901060066',
            contactEmail: 'jing.wang@kuaidaohd.com',
            companyAddress: '北京市朝阳区兆维工业园A1-1快道互动',
            companyNetwork: 'http://www.tloongroup.com/'
          },{
            type: '房产教育',
            logo: '//assets.cnbj1.mi-fds.com/assets/emi/index/agent/myy.jpg',
            companyName: '上海美逸雅文化传媒有限公司',
            contactName: '刘佳',
            contactMobile: '13436670667',
            contactEmail: 'liujia@meiyiya.cn',
            companyAddress: '北京市朝阳区酒仙桥北路乙十号院星地中心D座',
            companyNetwork: '无'
          },{
            type: '游戏行业',
            logo: '//assets.cnbj1.mi-fds.com/assets/emi/index/agent/taige2026.png',
            companyName: '武汉泰舸网络科技有限公司',
            contactName: '房琳',
            contactMobile: '15011204073',
            contactEmail: 'fanglin@tigecom.com',
            companyAddress: '北京市昌平区龙域中心B座11层1101',
            companyNetwork: 'http://tigecom.com'
          },{
            type: '游戏行业',
            logo: '//assets.cnbj1.mi-fds.com/assets/emi/index/agent/wkhy.jpg',
            companyName: '欢聚时代文化传媒（北京）有限公司',
            contactName: '王畅畅',
            contactMobile: '13552128520',
            contactEmail: 'wangchang@gm825.com',
            companyAddress: '北京市朝阳区酒仙桥路10号恒通商务园B22座4层',
            companyNetwork: 'http://www.wankacn.com/'
          }
        ]
      };
    },
  }
</script>
<style lang="scss">
@import "../assets/scss/core-agent.scss";
</style>